import { Directive, ViewContainerRef, inject } from '@angular/core';

@Directive({
  selector: '[libQuestionPlaceholder]',
})
export class QuestionControlPlaceholderDirective {
  public viewContainerRef: ViewContainerRef = inject(ViewContainerRef);
}
